import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { MapPin, Users, X, Send } from 'lucide-react';
import { getCatIcon, POSTIT_COLORS } from './constants';
import { getTimeAgo } from './utils';

export const PostCard = ({ post, user, onRespond, onResolve, onSendPostIt }) => {
  const cat = getCatIcon(post.category);
  const CatIcon = cat.icon;
  const isOwner = user?.user_id === post.user_id;
  const timeAgo = getTimeAgo(post.created_at);
  const postitBg = (() => {
    let hash = 0;
    const id = post.post_id || '';
    for (let i = 0; i < id.length; i++) hash = id.charCodeAt(i) + ((hash << 5) - hash);
    return POSTIT_COLORS[Math.abs(hash) % POSTIT_COLORS.length];
  })();

  return (
    <Card className={`bg-card/60 border-border/60 hover:border-border transition-colors ${post.urgent ? 'ring-1 ring-red-500/30' : ''}`} data-testid={`crisis-post-${post.post_id}`}>
      <CardContent className="p-3.5">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-start gap-2.5 flex-1 min-w-0">
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${post.type === 'need' ? 'bg-red-500/15' : 'bg-green-500/15'}`}>
              <CatIcon className={`w-4 h-4 ${cat.color}`} />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1.5 flex-wrap">
                <Badge className={`text-[9px] px-1.5 py-0 ${post.type === 'need' ? 'bg-red-500/20 text-red-400' : 'bg-green-500/20 text-green-400'}`}>
                  {post.type === 'need' ? 'NEED' : 'OFFER'}
                </Badge>
                {post.urgent && <Badge className="text-[9px] px-1.5 py-0 bg-red-600 text-white font-bold">URGENT</Badge>}
                <span className="text-[10px] text-muted-foreground">{timeAgo}</span>
              </div>
              <h3 className="text-sm font-medium text-foreground mt-1 leading-snug">{post.title}</h3>
              {post.description && <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">{post.description}</p>}
              <div className="flex items-center gap-3 mt-1.5 text-[10px] text-muted-foreground">
                <span>{post.user_name}</span>
                {post.location_text && <span className="flex items-center gap-0.5"><MapPin className="w-2.5 h-2.5" />{post.location_text}</span>}
                {post.responses > 0 && <span className="flex items-center gap-0.5"><Users className="w-2.5 h-2.5" />{post.responses} response{post.responses !== 1 ? 's' : ''}</span>}
              </div>
            </div>
          </div>
          <div className="flex flex-col items-end gap-1 flex-shrink-0">
            {!isOwner && user && (
              <button
                onClick={() => onSendPostIt({ user_id: post.user_id, name: post.user_name })}
                className="relative group cursor-pointer"
                style={{ width: 72, height: 72 }}
                data-testid={`postit-btn-${post.post_id}`}>
                <img src={postitBg} alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none select-none group-hover:scale-110 transition-transform" draggable={false} />
                <span className="relative flex flex-col items-center justify-center w-full h-full text-gray-800 font-bold">
                  <Send className="w-3 h-3 mb-0.5" />
                  <span className="text-[8px] leading-tight text-center">Send a<br/>Post-it</span>
                </span>
              </button>
            )}
            {isOwner && (
              <Button size="sm" variant="outline" className="text-[10px] h-7 rounded-lg border-border/30 text-muted-foreground hover:bg-muted/30"
                onClick={() => onResolve(post.post_id)} data-testid={`resolve-btn-${post.post_id}`}>
                <X className="w-3 h-3 mr-1" />Close
              </Button>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
